import React from "react";
import './Others.css';

function OtherBox({children}){
    return(
        <div className="Box12">
        {children}
        </div>
    )
}
export default OtherBox;